exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-item.search[data-v-2539638f]{position:absolute}.navbar-item.search .route-controls[data-v-2539638f]{position:absolute;right:1em}.navbar-item.search .route-controls .route-control[data-v-2539638f]{z-index:4;opacity:.8;cursor:pointer;margin-right:.2em}.navbar-item.search .route-controls .route-control[data-v-2539638f]:hover{opacity:1}@media screen and (min-width:1024px){.navbar-item.search[data-v-2539638f]{width:34em;left:calc(50% - 17em)}}@media screen and (min-width:768px) and (max-width:1023px){.navbar-item.search[data-v-2539638f]{width:26em;left:calc(50% - 13em)}}@media screen and (max-width:767px){.navbar-item.search[data-v-2539638f]{width:22em;left:calc(50% - 11em)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2539638f","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/core/structure/navbar/Search.vue
// module id = gmZW
// module chunks = 66